import awd1 from '../pic/awd1.jpg'
import awd11 from '../pic/awd1.1.jpg'
import awd2 from '../pic/awd2.jpg'
import awd22 from '../pic/awd2.1.jpg'
import awd3 from '../pic/awd3.jpg'
import awd4 from '../pic/awd4.jpg'
import awd5 from '../pic/awd5.jpg'
import awd6 from '../pic/awd6.jpg'
import awd7 from '../pic/awd7.jpg'
import awd8 from '../pic/awd8.jpg'
import awd81 from '../pic/awd8.1.jpg'
import awd9 from '../pic/awd9.png'
import awd10 from '../pic/edu.jpeg'
import awd101 from '../pic/edu.1.jpeg'
import awd12 from '../pic/IUBAT.jpg'
import awd13 from '../pic/KUET.jpg'
import awd14 from '../pic/UIU.jpg'

// --- AUST & WRO ACHIEVEMENTS ---
import aust_osc from '../pic/AUST_OSC.jpg'
import aust_rc from '../pic/AUST_RC.jpg'
import wro_team from '../pic/WRO_team.jpg'
import wro_teaminit from '../pic/WRO_team_INIT.jpg'

// --- NEW 2025 NATIONAL ACHIEVEMENTS ---
import cuet_ht from '../pic/CUET_HT1.jpg'
import cuet_mie from '../pic/CUET_MIE.jpg'
import duet_lfr from '../pic/DUET1.jpg'
import du_lfr from '../pic/DU_LFR.jpg'
import du_mm from '../pic/DU_MM.jpg'

const BlogApi = [
  {
    id: 1,
    image: awd6,
    ppimage: awd6,
    date: "20 December, 2022",
    title_one: "BUET Robo Carnival",
  },
  {
    id: 2,
    image: awd2,
    ppimage: awd22,
    date: "21 March, 2022",
    title_one: "Notre Dame Annual Science Festival",
  },
  {
    id: 3,
    image: awd3,
    ppimage: awd3,
    date: "20 December, 2022",
    title_one: "SUST Mechanical Festival 2022",
  },
  {
    id: 4,
    image: awd4,
    ppimage: awd4,
    date: "20 December, 2022",
    title_one: "GUB 4th Industrial Revolution for Sustainable Technology International Conference",
  },
  {
    id: 5,
    image: awd5,
    ppimage: awd5,
    date: "20 December, 2022",
    title_one: "RUET ETE Day",
  },
  {
    id: 6,
    image: awd1,
    ppimage: awd11,
    date: "1 November, 2021",
    title_one: "Bangladesh Robot Olympiad",
  },
  {
    id: 7,
    image: awd7,
    ppimage: awd7,
    date: "20 December, 2022",
    title_one: "IUBAT TechnoCrats Festival",
  },
  {
    id: 8,
    image: awd81,
    ppimage: awd8,
    date: "20 March, 2023",
    title_one: "Notre Dame Annual Science Festival",
  },
  {
    id: 9,
    image: awd9,
    ppimage: awd9,
    date: "20 March, 2023",
    title_one: "Notre Dame Annual Science Festival",
  },
  {
    id: 10,
    image: awd10,
    ppimage: awd101,
    date: "20 March, 2023",
    title_one: "East Delta University",
  },
  {
    id: 11,
    image: awd12,
    ppimage: awd12,
    date: "20 December, 2024",
    title_one: "International University of Business Agriculture and Technology",
  },
  {
    id: 12,
    image: awd13,
    ppimage: awd13,
    date: "3 January, 2025",
    title_one: "Khulna University of Engineering and Technology",
  },
  {
    id: 13,
    image: aust_osc,
    ppimage: aust_osc,
    date: "LFR Champion",
    title_one: "IEEE AUST OSCILLON - Team RoboMore",
  },
  {
    id: 14,
    image: aust_rc,
    ppimage: aust_rc,
    date: "ARC 2.0 Runner-Up",
    title_one: "AUST Rover Challenge - LFR Challenge",
  },
  {
    id: 15,
    image: du_lfr,
    ppimage: du_lfr,
    date: "August 2025",
    title_one: "DU Robotronics Fest 2025 - Runner Up LFR | Dynamic Spark",
  },
  {
    id: 16,
    image: cuet_ht,
    ppimage: cuet_ht,
    date: "July 2025",
    title_one: "Southern IoT Tech Carnival (CUET) - Champion | Team Hyper Thread",
  },
  {
    id: 17,
    image: cuet_mie,
    ppimage: cuet_mie,
    date: "May 2025",
    title_one: "MIE 1.0 Robolution (CUET) - Champion LFR | Team Solvewere",
  },
  {
    id: 18,
    image: awd6, 
    ppimage: awd6,
    date: "February 2026",
    title_one: "BUET Robocarnival - 2nd & 3rd Place | RoboMore Nex & Dynamic Spark",
  },
  {
    id: 19,
    image: du_mm,
    ppimage: du_mm,
    date: "August 2025",
    title_one: "DU Robotronics Fest 2025 - Runner Up Micromouse | Team Indur",
  },
  {
    id: 20,
    image: awd14,
    ppimage: awd14,
    date: "20 January, 2025",
    title_one: "United International University - Champion | Team RoboMore",
  },
  {
    id: 21,
    image: wro_team,
    ppimage: wro_teaminit,
    date: "November 2025",
    title_one: "WRO International Final (Singapore) - 29th Place | Team Echo Drift",
  },
  {
    id: 22,
    image: duet_lfr,
    ppimage: duet_lfr,
    date: "2025 Season",
    title_one: "DUET Techfest 2025 - 1st Runner Up LFR",
  }
];

export default BlogApi;